import { useNavigate } from "react-router";

export const ErrorPage = () => {
  const navigate = useNavigate();
  return (
    <>
      ErrorPage
      <button onClick={() => navigate(-1)}>back</button>
    </>
  );
};
